export default __webpack_public_path__ + "static/media/IconDesc_WreathNoBow.256.09e2fa37.png";